import React from "react";
import Grid from "@material-ui/core/Grid";
import { Typography, withStyles } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  circularProgress: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1)
  }
});

const Loading = (props) => <Grid
    container
    alignItems="center"      
    justify="center"
    style={{flex: "1 0 auto"}}
  >    
    <Grid item>
      <Typography component="h2" variant="h5" gutterBottom align="center">
        <CircularProgress className={props.classes.circularProgress} /> {props.children}
      </Typography>
    </Grid>
  </Grid>    

export default withStyles(styles)(Loading);